export { merge as deepMerge } from "ts-deepmerge";
